module.exports = __webpack_public_path__ + "static/media/user_friend_1.a6450dc5.png";